import { get } from '@/utils'
import { useFormikContext } from 'formik'

export const useCheckForm = <T>() => {
    const { errors, touched } = useFormikContext<T>()

    return {
        checkError: (key: string) => !!(get(errors, key) && get(touched, key)),
        getErrorStr: (key: string) => get(errors, key) && get(touched, key) && get(errors, key),
    }
}

export const checkError = (key: string, errors: any, touched: any) => !!(get(errors, key) && get(touched, key))

export const getErrorStr = (key: string, errors: any, touched: any) =>
    get(errors, key) && get(touched, key) && get(errors, key)

// 判断是否有字段含有值
export function checkValidate(error: any) {
    if (Object.prototype.toString.call(error) === '[object Array]') {
        for (let i = 0; i < error.length; i++) {
            if (!checkValidate(error[i])) {
                return false
            }
        }
    } else if (Object.prototype.toString.call(error) === '[object Object]') {
        for (let i in error) {
            if (!checkValidate(error[i])) {
                return false
            }
        }
    } else {
        if (error.trim().length !== 0) {
            return false
        }
    }
    return true
}
